/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, Fragment, useCallback, useEffect, useMemo, useRef } from "react";
import { Button, Icon, List, Text, useTheme } from "@bookingcom/bui-react";
import { useHistory, useLocation } from "react-router-dom";
import { I18nChildContext, Trans, useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { UIClientFetchError, UIFlightData } from "@flights/types";
import FlightCardMobile from "../FlightCard/FlightCard.mobile";
import SearchPagination from "../SearchPagination";
import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { SkeletonFlightCard } from "../Skeleton/SkeletonFlightCard";
import { TooManyFilters } from "./components/TooManyFilters";
import { NoResultsFound } from "./components/NoResultsFound";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../store";
import { useSelectorAppliedFilters } from "../../../store/selectors/appliedFilters";
import { getAvailableFilters } from "store/searchResults/selectors";
import { getExpandedSearchAirports } from "../../../store/selectors/expandedSearch";
import { FILTERS } from "../../../constants";
import { RemoveDirectFlights } from "./components/RemoveDirectFlights";
import useCreateUrl from "../../../hooks/useCreateUrl";
import SearchBaggagePolicies from "../SearchBaggagePolicies";
import { trackCustomGoal, trackExperiment, trackExperimentStage } from "utils/et";
import useClientCachedURL from "hooks/useClientCachedURL";
import RefreshResults from "./components/RefreshResults";
import NoDirectFlightsBanner from "./components/NoDirectFlightsBanner";
import useTrackExpRankerV3 from "hooks/useTrackExpRankerV3";
import { isOfMetaOrigin } from "utils/marketing-url-params";
import useGlobalContext from "hooks/useGlobalContext";
import useEventTracking from "hooks/useEventTracking";
import { SearchLoadingMessage } from "components/elements/SearchLoadingMessage";
import { getLocationParams } from "./utils";
import GeniusTCBanner from "cross-sell/components/GeniusTCBanner";
import Frame from "../Frame";
import { FlightCampaignTCBanner } from "../FlightCampaignTCBanner";
import { flightsSessionStore, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { FlexibleDateBestPrice } from "../FlexibleDateBestPrice";
import styles from "./SearchResults.module.css";
import { useFlexDatesRectrictedPOS } from "../FlexibleDateBestPrice/useFlexDatesRectrictedPOS";
import useProfiler from "../../../hooks/useProfiler";
import { RemoteAppleCardSR, WishlistWidgetLoaderMobile } from "components/remote";
import flights_apex_web_ancillaries_micro_conversion_aa from "../../../utils/experiments/apex/flights_apex_web_ancillaries_micro_conversion_aa";
import useOfferCartOrderData from "hooks/useOfferCartOrderData";
import useAlternativeFaresParams from "hooks/useAlternativeFaresParams";
import { useSelector } from "react-redux";
import { getEsimEligibilitySearch } from "ancillaries/store/esim/selectors";
import flights_ace_web_esim_banner, {
  useTrackEsimBannerStages
} from "utils/experiments/ace/flights_ace_web_esim_banner";
import EsimBanner from "ancillaries/components/Esim/EsimBanner";
import useIsInViewport from "hooks/useIsInViewport";
import Wrapper from "components/atoms/Wrapper";
import { useEsimSearch } from "ancillaries/hooks/Esim/useEsimFetch";
import flights_web_hide_genius_banner from "utils/experiments/funnel/flights_web_hide_genius_banner";
import flights_mdotvalue_flight_details_back_button from "utils/experiments/mdotvalue/flights_mdotvalue_flight_details_back_button";
import GeniusBanner from "cross-sell/components/GeniusBanner";
import useTrackFlightsFlexiBannerSourceChange from "utils/experiments/funnel/flights_web_flexi_banner_source_change_ml";
import { useStickySearchBoxExp } from "../../../utils/experiments/mdotvalue/flights_mdotvalue_sr_sticky_search_box";
import flights_web_sr_card_redesign_mdot_v2 from "utils/experiments/funnel/flights_web_sr_card_redesign_mdot_v2";
import { WhitelabelAncillaryBanner } from "ancillaries/components/Whitelabel/WhitelabelAncillaryBanner/WhitelabelAncillaryBanner";

import AiSummaryMobile from "./components/AiSummary.mobile";
import flights_web_sr_gen_ai_summary_v2_mdot from "utils/experiments/funnel/flights_web_sr_gen_ai_summary_v2_mdot";
import useLocaleContext from "hooks/useLocaleContext";
import dealsFilterExperiment from "utils/experiments/genius/flights_ade_sr_all_deals_filter";
import flights_split_bounds_us, { useTrackSplitBoundsStages } from "utils/experiments/funnel/flights_split_bounds_us";
import ddot_wl_save_flights from "utils/experiments/funnel/ddot_wl_save_flights";

type SearchResultsListProps = {
  flights: UIFlightData[];
  onSelectFlight: (flight: any) => void;
  dataTestId?: string;
};

function _SearchResultsList({ flights, onSelectFlight, dataTestId }: SearchResultsListProps) {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const {
    searchResults: { campaignBanner, remoteBanners, displayOptions }
  } = store;
  const appliedFilters = useSelectorAppliedFilters(store);
  const isRestricedFlexDatePOS = useFlexDatesRectrictedPOS();
  const { isLoggedOut, isDirect, isDesktop } = useProfiler();
  const params = new URLSearchParams(location.search);
  const currentSearchResultsPageNumber = params.get("page");
  const { locale } = useLocaleContext();

  /* start - flights_split_bounds_us */
  useTrackSplitBoundsStages();
  /* end - flights_split_bounds_us */

  // flights_web_flexi_banner_source_change_ml -- start
  const { trackStages } = useTrackFlightsFlexiBannerSourceChange();
  useEffect(() => {
    trackStages();
  }, [trackStages]);
  // flights_web_flexi_banner_source_change_ml -- end

  /** start - flights_web_hide_genius_banner */
  const trackingDivRef = useRef<HTMLDivElement>(null);
  const isTrackingDivVisible = useIsInViewport(trackingDivRef.current);

  useEffect(() => {
    if (!isLoggedOut() && isTrackingDivVisible) {
      flights_web_hide_genius_banner.stages.main();
      isDirect() ? flights_web_hide_genius_banner.stages.direct() : flights_web_hide_genius_banner.stages.meta();
      isDesktop() ? flights_web_hide_genius_banner.stages.desktop() : flights_web_hide_genius_banner.stages.mobile();
    }
  }, [isTrackingDivVisible, isLoggedOut, isDirect, isDesktop]);
  /** end - flights_web_hide_genius_banner */

  //There isn't a page param for the first search
  const isFirstSearchResultsPage = currentSearchResultsPageNumber ? Number(currentSearchResultsPageNumber) === 1 : true;

  useEffect(() => {
    flights_apex_web_ancillaries_micro_conversion_aa.trackSearchResultsStages(flights);
  }, [flights]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    trackExperimentStage("flight_web_sr_traffic_aa_mdot", 1);
    trackExperimentStage("flight_web_sr_traffic_aa_mdot", isOfMetaOrigin() ? 6 : 5);

    if (appliedFilters.length > 0) {
      trackExperimentStage("flight_web_sr_traffic_aa_mdot", 2);
    }
    if (store.user.userInfo && flightsSessionStore.get("genius_banner_seen")) {
      trackCustomGoal("flight_web_sr_traffic_aa_mdot", 5);
    }
  }, [appliedFilters, store.user.userInfo]);

  const shouldShowFlexDates =
    !displayOptions?.hideFlexiblePricesBanner &&
    flights.length >= 5 &&
    store.search.cabinClass === "ECONOMY" &&
    isFirstSearchResultsPage &&
    !isRestricedFlexDatePOS;

  const MARGIN_BOTTOM = !!trackExperiment("flights_web_mdot_sr_card_single_cta") ? 2 : undefined;
  const MARGIN_TOP = !!trackExperiment("flights_web_mdot_sr_card_single_cta") ? 0 : undefined;

  /** start - flights_ace_web_esim_banner */
  const isEsimEligible = !!useSelector(getEsimEligibilitySearch);
  const showEsimBanner = isEsimEligible && !!flights_ace_web_esim_banner.trackWithDefaultStage();
  const ESIM_BANNER_SEARCH_RESULTS_INDEX = 6;
  const WHITELABEL_BANNER_SEARCH_RESULTS_INDEX = 7;
  const fetchEsim = useEsimSearch();
  const esimBannerRef = useRef<HTMLDivElement>(null);
  const eSimInViewport = useIsInViewport(esimBannerRef.current);
  /** end - flights_ace_web_esim_banner */
  useTrackEsimBannerStages(isEsimEligible);

  const availableFilters = useSelector(getAvailableFilters);
  isLoggedOut() ? null : dealsFilterExperiment.stages.users_in_sr();
  !!availableFilters.deals
    ? dealsFilterExperiment.useTrackStagesAllDealsFilter(
        appliedFilters.length > 0,
        appliedFilters.includes(FILTERS.allDeals)
      )
    : null;

  const renderGeniusBanner = () => {
    if (isLoggedOut()) {
      return null;
    }

    /** start - flights_web_hide_genius_banner */
    if (flights_web_hide_genius_banner.trackWithDefaultStage()) {
      return <div ref={trackingDivRef}></div>;
    }
    /** end - flights_web_hide_genius_banner */

    return (
      <Frame mt={MARGIN_TOP} mb={MARGIN_BOTTOM}>
        <GeniusBanner />
        {/** start - flights_web_hide_genius_banner */}
        <div ref={trackingDivRef}></div>
        {/** end - flights_web_hide_genius_banner */}
        <SearchTrafficAAGeniusTrackerMdot />
      </Frame>
    );
  };

  /* start - flights_web_flexible_date_search */
  useEffect(() => {
    void fetchEsim();
  }, [fetchEsim]);

  useEffect(() => {
    if (eSimInViewport) {
      flights_ace_web_esim_banner.stages.viewed_esim_banner_sr_page();
      flights_ace_web_esim_banner.goals.viewed_esim_banner();
    }
  }, [eSimInViewport]);
  /* end - flights_web_ace_esim_banner */

  const isEligibleForAiSummary = locale?.code.toLowerCase().startsWith("en-");
  const aiSummaryTrackingDivRef = useRef<HTMLDivElement>(null);
  const isAiSummaryTrackingDivVisible = useIsInViewport(aiSummaryTrackingDivRef.current);
  flights_web_sr_gen_ai_summary_v2_mdot.useTrackStages(isAiSummaryTrackingDivVisible);

  return (
    <div className={styles.searchResultsList} data-testid={dataTestId}>
      <List attributes={{ style: { padding: 0 } }}>
        {flights.map((flight: any, index: number) => {
          return (
            <Fragment key={`${index}_${flight.token}`}>
              {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              campaignBanner &&
              index === campaignBanner.position ? (
                <Frame mt={MARGIN_TOP} mb={MARGIN_BOTTOM}>
                  <FlightCampaignTCBanner campaignBanner={campaignBanner} />
                </Frame>
              ) : null}

              {isEligibleForAiSummary && index === 5 && (
                <div ref={aiSummaryTrackingDivRef}>
                  {flights_web_sr_gen_ai_summary_v2_mdot.trackWithDefaultStage() ? <AiSummaryMobile /> : null}
                </div>
              )}

              <div id={`flightcard-${index}`} data-testid="searchresults_card">
                <FlightCardMobile
                  flight={flight}
                  index={index}
                  onClick={onSelectFlight}
                  pricePerPerson
                  mt={MARGIN_TOP}
                  mb={MARGIN_BOTTOM}
                />
              </div>
              <Frame mb={MARGIN_BOTTOM}>{shouldShowFlexDates && index === 0 ? <FlexibleDateBestPrice /> : null}</Frame>
              {/* Always display CrossSell banner after second item if Genius campaign is disabled */}
              {/* hide crossSell when exp: flights_web_credit_campaign is in variant */}
              {!campaignBanner && index === 1 ? renderGeniusBanner() : null}
              {/* If GeniusCampaign is Enabled, show the Genius TC campaign on 3rd position */}
              {!isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              index === 1 &&
              campaignBanner ? (
                <Frame mt={MARGIN_TOP} mb={MARGIN_BOTTOM}>
                  <GeniusTCBanner campaignBanner={campaignBanner} />
                  <SearchTrafficAAGeniusTrackerMdot />
                </Frame>
              ) : null}
              {/**
               * If the position is larger than the number of cards displayed in the SR page,
               * then the T&C banner is shown after the last card.
               * More info: https://jira.booking.com/jira/browse/FPRICING-809
               */}
              {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              campaignBanner &&
              campaignBanner.position >= flights.length && // campaign banner position is larger than the number of cards
              index >= flights.length - 1 ? ( // after the last flight card
                <Frame mt={MARGIN_TOP} mb={MARGIN_BOTTOM}>
                  <FlightCampaignTCBanner campaignBanner={campaignBanner} />
                </Frame>
              ) : null}
              {/* If GeniusCampaign is Enabled, show the ABU campaign on 6th position */}
              {campaignBanner && index === 4 ? renderGeniusBanner() : null}

              {/* start - flights_ace_web_esim_banner */}
              {showEsimBanner && index === ESIM_BANNER_SEARCH_RESULTS_INDEX ? (
                <Wrapper
                  elementRef={esimBannerRef}
                  noBorder
                  noPadding
                  noPaddingVertical
                  style={{ paddingBottom: "8px" }}
                >
                  <EsimBanner context="search" />
                </Wrapper>
              ) : null}
              {/* end - flights_ace_web_esim_banner */}

              {index === WHITELABEL_BANNER_SEARCH_RESULTS_INDEX ? (
                <WhitelabelAncillaryBanner ancillary="loungeAccess" />
              ) : null}

              {Array.isArray(remoteBanners) && remoteBanners.includes("APPLE_CARD_BANNER_SR") && index === 4 ? (
                <RemoteAppleCardSR />
              ) : undefined}
            </Fragment>
          );
        })}
      </List>
    </div>
  );
}

const SearchResultsList = React.memo(_SearchResultsList);

interface SearchResultsProps {
  airports: string;
  params: string;
  fetchStatus: string;
  fetchError?: UIClientFetchError;
  flights: UIFlightData[];
  onSelectFlight: () => void;
}

const SearchResults = ({ airports, params, flights = [], fetchStatus, onSelectFlight }: SearchResultsProps) => {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const { isDirect, isOneWay, isRountrip, isSolo, isFamily, isPointOfSale, isLoggedIn } = useProfiler();
  const { createUrl } = useCreateUrl();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const {
    search,
    searchResults,
    flexibleDateMinPrice: { fetchStatus: flexibleDatePriceFetchStatus }
  } = store;
  const { error } = searchResults;
  const appliedFilters = useSelectorAppliedFilters(store);
  const i18n = useI18n() as I18nChildContext;
  const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
  const trackExpRankerV3 = useTrackExpRankerV3();
  const { requestId } = useGlobalContext();
  const trackV2 = useEventTracking("search_results", requestId);
  const isRestricedFlexDatePOS = useFlexDatesRectrictedPOS();
  const offerCartOrderData = useOfferCartOrderData();
  const { setAlternativeFaresParams } = useAlternativeFaresParams();

  /*@start flights_mdotvalue_sr_sticky_search_box*/
  const { trackReachedEndOfPage } = useStickySearchBoxExp();
  const endOfPageRef = useRef(null);
  const reachedEndOfPage = useIsInViewport(endOfPageRef.current);

  useEffect(() => {
    if (reachedEndOfPage) {
      trackReachedEndOfPage();
    }
  }, [reachedEndOfPage, trackReachedEndOfPage]);
  /*@end flights_mdotvalue_sr_sticky_search_box*/

  useEffect(() => {
    // START - flights_mdotvalue_flight_details_back_button
    if (flightsSessionStore.get("clickedFlightDetails")) {
      flights_mdotvalue_flight_details_back_button.goals.onBackToSr();
      flights_mdotvalue_flight_details_back_button.goals.onFlightExit();
    }
    flightsSessionStore.set("clickedFlightDetails", false);
    // END - flights_mdotvalue_flight_details_back_button

    if (["loading", "initial"].includes(fetchStatus)) return;
    if (flights.length === 0) trackV2("show_empty_search_results");
  }, [flights, fetchStatus, trackV2]);

  /* start - flights_web_sr_card_redesign_mdot_v2*/
  useEffect(() => {
    if (fetchStatus === "success" && flights.length > 0) {
      flights_web_sr_card_redesign_mdot_v2.trackWithDefaultStage();
      isDirect()
        ? flights_web_sr_card_redesign_mdot_v2.stages.direct()
        : flights_web_sr_card_redesign_mdot_v2.stages.meta();
      isOneWay() && flights_web_sr_card_redesign_mdot_v2.stages.oneWay();
      isRountrip() && flights_web_sr_card_redesign_mdot_v2.stages.roundTrip();
      isSolo() && flights_web_sr_card_redesign_mdot_v2.stages.solo();
      isFamily() && flights_web_sr_card_redesign_mdot_v2.stages.family();
      isPointOfSale("us") && flights_web_sr_card_redesign_mdot_v2.stages.us();
    }
  }, [fetchStatus, flights.length, isDirect, isOneWay, isRountrip, isSolo, isFamily, isPointOfSale]);
  /* end - flights_web_sr_card_redesign_mdot_v2 */

  const showFlightDetails = useCallback(
    async (flight: any) => {
      flights_split_bounds_us.goals.cta_click();
      trackCustomGoal("flights_meta_land_on_cheapest_flights", 4); //select flight

      onSelectFlight();

      // flights_mdotvalue_flight_details_back_button
      flightsSessionStore.set("clickedFlightDetails", true);

      offerCartOrderData.set(flight.token, {
        offer: flight.token,
        cabinClass: searchResults.searchCriteria?.cabinClass
      });
      history.push(createUrl(`/flights/${airports}/${flight.token}/?${getLocationParams(params)}`), {
        fromSearch: true
      });
    },
    [onSelectFlight, offerCartOrderData, searchResults.searchCriteria?.cabinClass, history, createUrl, airports, params]
  );

  const changeSearch = useCallback(() => {
    history.push(createUrl("/"));
  }, [history, createUrl]);

  const expandedSearchAirports = useMemo(() => {
    const { searchSegments } = search;
    /*eslint-disable-next-line flights/no-unassigned-todo-comments*/
    /**
     * TODO: Update ExpandedSeach for multistop cases?
     */
    const { from, to } = searchSegments[0];
    return getExpandedSearchAirports(from, to);
  }, [search]);

  const expandToCitySearch = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (expandedSearchAirports) {
        const { fromCities, toCities, fromLocationName, toLocationName } = expandedSearchAirports;
        const params = new URLSearchParams(location.search);
        params.set("from", fromCities);
        params.set("to", toCities);
        params.set("fromLocationName", fromLocationName);
        params.set("toLocationName", toLocationName);

        history.replace(createUrl(`/flights/${fromCities}-${toCities}/?${params}`));
        window.location.reload();
      }
    },
    [history, location, expandedSearchAirports, createUrl]
  );

  // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
  const noFlightsFound = error && error["code"] === "SEARCH_SEARCHFLIGHTS_NO_FLIGHTS_FOUND";
  const canExtendSearch = appliedFilters.length === 0 && noFlightsFound && expandedSearchAirports;
  const canRemoveDirectFlightsFilter = appliedFilters.includes(FILTERS.stops) && flights.length === 0;

  const flexibleLoadingCondition =
    store.search.cabinClass === "ECONOMY" && !isRestricedFlexDatePOS
      ? flexibleDatePriceFetchStatus === "initial" || flexibleDatePriceFetchStatus === "loading"
      : false;

  if (fetchStatus === "initial" || fetchStatus === "loading" || flexibleLoadingCondition) {
    return (
      <>
        <SearchLoadingMessage />
        <div className={styles.loading}>
          <SkeletonFlightCard />
          <SkeletonFlightCard />
          <SkeletonFlightCard />
          <SkeletonFlightCard />
        </div>
      </>
    );
  }

  if (fetchStatus === "success") {
    if (flights.length > 0) {
      cacheLastSuccessfulSearchUrl(airports);
      searchResults.fetchedAt && setAlternativeFaresParams("searchedAt", searchResults.fetchedAt);
      trackExpRankerV3.trackStages();
      return (
        <div className={styles.searchResults}>
          <NoDirectFlightsBanner />
          <SearchBaggagePolicies />
          <SearchResultsList flights={flights} onSelectFlight={showFlightDetails} dataTestId="searchresults_list" />
          {/*@start flights_mdotvalue_sr_sticky_search_box*/}
          <div ref={endOfPageRef}></div>
          {/*@end flights_mdotvalue_sr_sticky_search_box*/}
          <SearchPagination />
          <RefreshResults flights={flights} />
          {isLoggedIn() && !!ddot_wl_save_flights.trackWithDefaultStage() ? <WishlistWidgetLoaderMobile /> : null}
        </div>
      );
    } else if (canRemoveDirectFlightsFilter) {
      return <RemoveDirectFlights />;
    }
  }

  if (fetchStatus === "failed") {
    if (canExtendSearch) {
      return (
        <Frame mt={6} mb={6} attributes={{ style: { minHeight: "40vh" } }}>
          <Frame m={3} alignItems="center" attributes={{ style: { textAlign: "center" } }}>
            <Icon svg={SearchRemoveIcon} size="small" className={styles.searchRemoveIcon} />
            <Text variant="headline_2">{i18n.trans(t("flights_search_no_results_header"))} </Text>
          </Frame>
          {search.type !== "MULTISTOP" && (
            <Text variant="body_2">
              <Trans
                tag="flights_search_no_results_copy_mobile"
                variables={{ start_link: "<0>", end_link: "</0>" }}
                components={[
                  <a
                    key={0}
                    href="##"
                    style={{ color: theme.colors.color_action_foreground }}
                    onClick={expandToCitySearch}
                  />
                ]}
              />
            </Text>
          )}
          <Frame alignItems="center" m={6}>
            <Button onClick={changeSearch}>{i18n.trans(t("flights_search_no_results_change_search_cta"))}</Button>
          </Frame>
        </Frame>
      );
    }
  }

  if (appliedFilters.length > 0) {
    return <TooManyFilters />;
  } else {
    return <NoResultsFound showActions={true} />;
  }
};

export const SearchTrafficAAGeniusTrackerMdot: FC = () => {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();

  useEffect(() => {
    if (!store.user.userInfo) {
      trackExperimentStage("flight_web_sr_traffic_aa_mdot", 4);
      flightsSessionStore.set("genius_banner_seen", true);
    }
  }, [store.user.userInfo]);

  return null;
};

export default React.memo(SearchResults);
